module.exports = __webpack_public_path__ + "media/icons/key-1-dark-1ee1408b.svg";